import {
  SESSION_REQUEST,
  SESSION_SUCCESS,
  SESSION_FAIL,
  SESSION_CLOSE_REQUEST,
  SESSION_CLOSE_SUCCESS,
  SESSION_CLOSE_FAIL,
} from "../actions/sessionActions";


const initialState = {
  loading: false,

  sessionId: null,

  sessionToken: null,

  restaurantId: null,

  tableId: null,

  error: null,

  closing: false,

  closeError: null,

  closed: false,
};


const sessionReducer = (
  state = initialState,
  action
) => {

  switch (action.type) {


    // =====================================================
    // CREATE SESSION - REQUEST
    // =====================================================

    case SESSION_REQUEST:

      return {
        ...state,

        loading: true,

        error: null,

        closed: false,
      };


    // =====================================================
    // CREATE SESSION - SUCCESS
    // =====================================================

    case SESSION_SUCCESS:

      return {
        ...state,

        loading: false,

        sessionId:
          action.payload.session_id,

        sessionToken:
          action.payload.session_token,

        restaurantId:
          action.payload.restaurant_id,

        tableId:
          action.payload.table_id,

        error: null,

        closed: false,
      };


    // =====================================================
    // CREATE SESSION - FAIL
    // =====================================================

    case SESSION_FAIL:

      return {
        ...state,

        loading: false,

        error:
          action.payload,
      };


    // =====================================================
    // CLOSE SESSION - REQUEST
    // =====================================================

    case SESSION_CLOSE_REQUEST:

      return {
        ...state,

        closing: true,

        closeError: null,
      };


    // =====================================================
    // CLOSE SESSION - SUCCESS
    // =====================================================

    case SESSION_CLOSE_SUCCESS:

      return {
        ...state,

        closing: false,

        closed: true,

        closeError: null,

        // Session is no longer active.
        // Keep the token temporarily so the
        // calling code can still know which
        // session was closed.
        sessionId:
          action.payload.session_id,

        sessionToken:
          action.payload.session_token,

        restaurantId:
          action.payload.restaurant_id,

        tableId:
          action.payload.table_id,
      };


    // =====================================================
    // CLOSE SESSION - FAIL
    // =====================================================

    case SESSION_CLOSE_FAIL:

      return {
        ...state,

        closing: false,

        closeError:
          action.payload,
      };


    default:

      return state;
  }
};


export default sessionReducer;